import { checkSnilsOnlyChecksum } from 'ru-validation-codes';
import type { TestContext, TestFunction } from 'yup';

export const isCorrectSnils: TestFunction<string | undefined> = (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const snils = String(value).replace(/\D/g, '');
  const isValid = snils ? checkSnilsOnlyChecksum(snils) : true;
  return isValid || context.createError({ path: context.path, message: 'Введен неверный СНИЛС' });
};
